export default {
    'name': 'shoppers',
    'width': '24',
    'height': '24',
    'viewBox': '0 0 24 24',
    'data': '<g clip-path=\'url(#clip0_6995_970)\'><path d=\'M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z\' fill=\'#F2F4F8\'/><path d=\'M6.2041 17.9558V4.86621H8.0673V11.2718C10.6656 11.7768 13.3378 11.7768 15.9361 11.2718V4.86621H17.7965V18.095C17.7965 18.6687 17.3888 19.1338 16.8845 19.1338H16.1841C13.4192 18.6584 10.5927 18.6584 7.82775 19.1338H7.1273C6.61177 19.1324 6.2041 18.5295 6.2041 17.9558Z\' fill=\'#FA481B\'/></g><defs><clipPath id=\'clip0_6995_970\'><rect width=\'24\' height=\'24\' fill=\'white\'/></clipPath></defs>'
}
